import script from "./ApresSkisDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./ApresSkisDetalle.vue?vue&type=script&setup=true&lang=js"

import "./ApresSkisDetalle.vue?vue&type=style&index=0&id=3daf53d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3daf53d4"]])

export default __exports__